import React, { Component } from 'react';
import FormDataJson from 'form-data-json-convert';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Slideshow from './Slideshow';
import ProductImageView from './Products/ProductImageView';
import Attributes from './Attributes';
import Addons from './Addons';
import SelectedProduct from '../../entities/SelectedProduct';
import { setTorsoText, setTorsoOverlay } from '../../actions';
import ProductWarningText from './Products/ProductWarningText';
import { convertFileToBase64 } from '../../wordpress';
import Warning from './Warning';

/**
 * Customise product screen
 *
 * Allows for entering details for the product
 *
 * @author John Noel <john.noel@joipolloi.com>
 * @author Ben Ghabili <ben.ghabili@joipolloi.com>
 * @author Matt Haynes <Matthew.haynes@joipolloi.com>
 * @package Minifigs
 */
class Customise extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // the selected state for these
            attributes:
                props.selected && props.selected.attributes !== null
                    ? props.selected.attributes
                    : this.getDefaultValue().attr,
            addons: props.selected !== null ? props.product_attribute : [],
            showingCopyright: false,
            hasOverLay: false,
            dropdownDefaultValue: this.getDefaultValue().id,
            productMatchAttr: this.getDefaultValue().attr,
            productFormJsonValues: null,
            frontTextEventListenerExists: false,
            backTextEventListenerExists: false,
            torsoOverlayImages: {
                handImage: '',
                torsoOverlayImage: '',
            },
            torsoText: {
                frontText: '',
                backText: '',
            },
            torsoBackImage: null,
            showBackImage: false,
            showReplaceItemWarning: false,
            formToSubmit: null,
            currentBuildIndex: props.currentBuildIndex,
        };

        this.submitProductForm = this.submitProductForm.bind(this);
        this.isOverlay = this.isOverlay.bind(this);
    }

    /**
     * This will mount the isOverlay just before render
     */
    componentWillMount() {
        this.isOverlay();
    }

    componentDidMount() {
        const { selectedProducts, activeSection, product } = this.props;
        const sectionHasProduct = selectedProducts[activeSection] !== null;

        if (
            sectionHasProduct &&
            activeSection === 'bodies' &&
            selectedProducts[activeSection].product?.id === product.id
        ) {
            this.setState({
                torsoText: {
                    frontText: this.props.torsoReduxText.frontText,
                    backText: this.props.torsoReduxText.backText,
                },
            });
        }

        if (activeSection === 'bodies') {
            this.setBackImage();
            this.setOverlayImage();
        }
    }

    componentDidUpdate(prevProps) {
        const { skintone } = this.props;

        if (skintone !== prevProps.skintone) {
            this.setOverlayImage();
            this.setBackImage();
        }
    }

    submitProductForm(clickedButtonForm) {
        const { dispatch, product, onSelect, activeSection } = this.props;
        const { addonArr } = window;
        let validated = false;

        // Validate required fields
        if (addonArr && addonArr !== false) {
            const boldOptionSets = Array.from(document.querySelectorAll('.bold_option_set'));
            const passedValidation = [];

            boldOptionSets.forEach((optionSet, index) => {
                const options = Array.from(optionSet.querySelectorAll('.bold_option'));
                const addonArrValues = addonArr[index].options;

                options.forEach(async (option, idx) => {
                    if (addonArrValues[idx]) {
                        let optSetValLength;
                        if (option.querySelector('textarea')) {
                            optSetValLength = option.querySelector('textarea').value.replace(/\s/g, '').length;
                        } else if (option.querySelector('input[type=file]')) {
                            optSetValLength = option.querySelector('input[type=file]').value.length;
                            const input = option.querySelector('input[type=file]');
                            const file = option.querySelector('input[type=file]')['files'][0];
                            const regex = /\[(.*?)\]/;
                            const match = regex.exec(input.name);
                            const name = match ? match[1] : input.name;

                            const encodedImage = await convertFileToBase64(file);
                            if (validated && (!addonArrValues[idx].required || optSetValLength > 0)) {
                                this.setState({
                                    productFormJsonValues: {
                                        ...this.state.productFormJsonValues,
                                        properties: {
                                            ...this.state.productFormJsonValues.properties,
                                            [name]: encodedImage,
                                        },
                                    },
                                });
                                onSelect(
                                    product,
                                    this.state.attributes,
                                    this.state.addons,
                                    this.state.productMatchAttr,
                                    this.state.productFormJsonValues
                                );
                            }

                            if (addonArrValues[idx].required && optSetValLength === 0) {
                                validated = false;
                            }
                        } else if (option.querySelector('input')) {
                            optSetValLength = option.querySelector('input').value.replace(/\s/g, '').length;
                        } else if (option.querySelector('select')) {
                            optSetValLength = option.querySelector('select').value.length;
                        } else if (option.querySelector('file')) {
                            optSetValLength = option.querySelector('file').value.length;
                        }

                        if ((addonArrValues[idx].required && optSetValLength > 0) || !addonArrValues[idx].required) {
                            passedValidation.push(true);
                        } else if (addonArrValues[idx].required && optSetValLength === 0) {
                            passedValidation.push(false);
                            optionSet.classList.add('validation-error');
                            optionSet.parentElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        }
                    }
                });

                if (passedValidation.includes(false)) {
                    optionSet.classList.add('validation-error');
                    optionSet.parentElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    validated = false;
                } else {
                    optionSet.classList.remove('validation-error');
                    validated = true;
                }
            });
        }

        if (!validated && addonArr) {
            return false;
        }

        this.setState({ productFormJsonValues: FormDataJson.toJson(clickedButtonForm) });

        const warnings = document.querySelectorAll('.please-choose-warning');
        const formAttributes = document.querySelector('.attributes .product-variation');
        if (warnings.length > 0) {
            if (this.state.dropdownDefaultValue === '') {
                warnings.forEach((warning) => {
                    warning.style.display = 'inline-block';
                });
                formAttributes.scrollIntoView({ behavior: 'smooth' });
            } else {
                warnings.forEach((warning) => {
                    warning.style.display = 'none';
                });
            }
        }

        // Have to run this again because the async call above tries to validate the form before knowing
        // if there is an image field present... once we know there is a file field, we can let the function
        // above, which attaches the image to the json data, be responsible for validating that there is
        // an image present
        let hasFileField = false;
        if (addonArr && addonArr !== false) {
            const boldOptionSets = Array.from(document.querySelectorAll('.bold_option_set'));
            boldOptionSets.forEach((optionSet) => {
                const options = Array.from(optionSet.querySelectorAll('.bold_option'));
                options.forEach((option) => {
                    if (option.querySelector('input[type=file]')) {
                        hasFileField = option.querySelector('input[type=file]');
                    }
                });
            });
        }

        const productNodes = product.variants.nodes ? product.variants.nodes : product.variants.edges;
        if (!hasFileField) {
            for (let i = 0, n = productNodes.length; i < n; i += 1) {
                const productId = productNodes[i]?.node
                    ? productNodes[i]?.node.id.split('/').pop()
                    : productNodes[i]?.id.split('/').pop();
                if (productId == this.state.dropdownDefaultValue && productNodes[i] !== 'undefined') {
                    this.setState(
                        {
                            productMatchAttr: productNodes[i].node,
                        },
                        function () {
                            if (activeSection === 'bodies') {
                                dispatch(setTorsoOverlay(this.state.currentBuildIndex, this.state.torsoOverlayImages));
                                dispatch(
                                    setTorsoText(this.state.currentBuildIndex, {
                                        frontText: this.state.torsoText.frontText,
                                        backText: this.state.torsoText.backText,
                                    })
                                );
                            }

                            onSelect(
                                product,
                                this.state.attributes,
                                this.state.addons,
                                this.state.productMatchAttr,
                                this.state.productFormJsonValues
                            );
                        }
                    );
                }
            }
        } else if (!addonArr) {
            this.setState(
                {
                    productMatchAttr: product.variants.nodes
                        ? product.variants.nodes[0]
                        : product.variants.edges[0].node,
                },
                function () {
                    if (activeSection === 'bodies') {
                        dispatch(setTorsoOverlay(this.state.torsoOverlayImages));
                        dispatch(
                            setTorsoText({
                                frontText: this.state.torsoText.frontText,
                                backText: this.state.torsoText.backText,
                            })
                        );
                    }

                    onSelect(
                        product,
                        this.state.attributes,
                        this.state.addons,
                        this.state.productMatchAttr,
                        this.state.productFormJsonValues
                    );
                }
            );
        }
    }

    /**
     * Change the variation for the selected attribute
     *
     * @param {object} attribute
     * @param {string} selectedValue
     */
    changeAttribute(attribute, selectedValue) {
        const { activeSection } = this.props;
        let attr = attribute;
        this.setState({ dropdownDefaultValue: selectedValue });
        this.setState({ productMatchAttr: attr });
        this.setState({ attributes: attr }, () => {
            if (activeSection === 'bodies') {
                this.setOverlayImage();
                this.setBackImage();
            }
        });
    }

    /**
     * Change the value for the addon and option
     *
     * @param {object} addon
     * @param {number} option The index of the option being changed
     * @param {mixed} value Type of value depends on addon.type
     */

    // -- Commenting out for now... ---
    changeAddon(addon, option, value) {
        let addons = this.state.addons,
            originalLength = addons.length;

        addons = addons.filter((v) => !(v.addon === addon && v.option === option));

        // if the addon is a checkbox, the value we get is actually a toggle
        // rather than just changing the value
        if (addon.type === 'checkbox') {
            // if we haven't removed an item (i.e. it hasn't been toggled off)
            if (addons.length === originalLength) {
                addons.push({ addon, option, value });
            }
        } else if (addon.type === 'radio' || addon.type === 'select') {
            // need to remove the addon entirely regardless of option, and
            // replace it with the current value
            addons = addons.filter((v) => v.addon !== addon);
            addons.push({ addon, option, value });
        } else if (value) {
            addons.push({ addon, option, value });
        }

        this.setState({ addons });
    }

    /**
     * Get the price for this product according to sale, base, addons and
     * variations
     *
     * @return {number}
     */
    getPrice(product, attributes, addons, productFormJsonValues) {
        return new SelectedProduct(product, null, attributes, addons, null, null, productFormJsonValues).getPrice();
    }

    /**
     * Get the overlay image if the product tagged as overlay
     * variations
     *
     * @return {string}
     */
    getOverLayImage(product, attributes) {
        let overLayImage = new SelectedProduct(product, null, attributes, null).getOverLayImage();

        if (overLayImage) {
            return overLayImage;
        }

        const returnImage = product.images && product.images[0] && product.images[0].src;

        return returnImage;
    }

    /**
     * Figures out if the product has overlay tag assigned
     *
     * @return {boolean}
     */
    isOverlay() {
        const { product } = this.props;

        if (typeof product !== 'undefined' && typeof product.tags !== 'undefined') {
            let productTags = product.tags;
            productTags.forEach((tags) => {
                const tag = tags.replace(/\s/g, '');
                if ('overlay' === tag && this.state.hasOverLay === false) {
                    this.setState({ hasOverLay: true });
                }
            });
        }
    }

    /**
     * [[image, associateBaseImage1], [image, associateBaseImage1], [image, associateBaseImage2], [image, associateBaseImage2], [] , ...]
     * otherwise return a simple array - refer to getSimpleImageArray()
     *
     * @return {Array}
     */
    getProductImages() {
        const { product } = this.props;
        let mappedArray = [];
        let svgArray = [];

        if (!product.images) {
            console.error('No images found');
            return mappedArray;
        }

        for (let i = 0; i < product.images.edges.length; i++) {
            if (product.images.edges[i].node.url.match(/PNGOVERLAY/gi)) {
                svgArray.push(product.images.edges[i].node.url);
            }
        }

        if (svgArray.length === 0 || !this.state.hasOverLay) {
            return this.getSimpleImageArray(product.images.edges);
        }

        let svgIndex = 0;
        product.images.edges.map((image) => {
            if (image.src !== svgArray[svgIndex]) {
                mappedArray.push([image.node.url, svgArray[svgIndex]]);
            }

            if (image.src === svgArray[svgIndex + 1]) {
                svgIndex++;
            }
        });

        return mappedArray;
    }

    /**
     * Returns the simple image array containing the images in the first index and empty '' (string)
     * as the second element - for consistency purpose
     * array in the form of [[image, ""], [image, ""], [], [], [],...]
     *
     *
     * @param images
     * @return {Array}
     */
    getSimpleImageArray(images) {
        let imageArray = [];
        if (typeof images === 'object') {
            images.map((image) => {
                imageArray.push([image.node.url, '']);
            });
        }

        return imageArray;
    }

    /**
     * Define whether the attribute dropdown has default value set
     * @return {Array}
     */
    getDefaultValue() {
        const { skintone, product, activeSection } = this.props;
        const variations = product.variants.nodes
            ? product.variants.nodes
            : product.variants.edges.map((edge) => edge.node);

        let attr = variations[0];
        if (activeSection === 'heads' && skintone) {
            attr =
                variations.find((attr) => attr.title.toLowerCase().includes(skintone.toLowerCase())) || variations[0];
        }

        const id = attr?.id?.split('/').pop();
        return { id, attr };
    }

    /**
     * Set product overlay image based on light/dark metafield and currnently selcted skintone
     */
    setOverlayImage() {
        const { skintone, product, activeSection } = this.props;
        const { attributes } = this.state;
        const handImages = {
            dark: 'https://cdn.shopify.com/s/files/1/0223/5446/0736/files/DarkHands-ForTorsoOverlay.png?v=1721912777',
            light: 'https://cdn.shopify.com/s/files/1/0223/5446/0736/files/LightHands-ForTorsoOverlay.png?v=1721912777',
            yellow: 'https://cdn.shopify.com/s/files/1/0223/5446/0736/files/YellowHands-ForTorsoOverlay.png?v=1721912778',
            nougat: 'https://cdn.shopify.com/s/files/1/0223/5446/0736/files/NougatHands-ForTorsoOverlay.png?v=1721912778',
            medium: 'https://cdn.shopify.com/s/files/1/0223/5446/0736/files/MediumHands-ForTorsoOverlay.png?v=1721912778',
        };

        let activeTorso = attributes;
        if (product.variants.nodes.length === 1) {
            activeTorso = product.variants.nodes[0];
        }

        const imageStringToFind = `${
            activeTorso?.torsoOverlayValue?.value === 'Light' ? 'Colour' : activeTorso?.torsoOverlayValue?.value
        }-Artwork---${skintone}`;
        const defaultImageStrings = `${
            activeTorso?.torsoOverlayValue?.value === 'Light' ? 'Colour' : activeTorso?.torsoOverlayValue?.value
        }-Artwork---default`;
        let torsoOverlayImage = '';
        product.images.edges.forEach((image) => {
            if (image.node.url.toLowerCase().includes(imageStringToFind.toLowerCase())) {
                torsoOverlayImage = image.node.url;
            } else if (image.node.url.toLowerCase().includes(defaultImageStrings.toLowerCase())) {
                torsoOverlayImage = image.node.url;
            }
        });

        const handImage = handImages[skintone.toLowerCase()];

        this.setState({
            torsoOverlayImages: {
                handImage,
                torsoOverlayImage,
            },
        });
    }

    /**
     * Find back image for currently selected torso attribute from array of images...
     */
    setBackImage() {
        const { skintone, product, activeSection } = this.props;
        const { attributes } = this.state;

        const attr = attributes?.title?.toLowerCase().replaceAll(' ', '');
        let torsoBackImage = '';
        let torsoBackImageSkintone = '';
        product.images.edges.forEach((image) => {
            if (attr && attr !== 'defaulttitle') {
                const imageStringWithAttrAndSkinToneToFind = `${attr}-Artwork-Back---${skintone}`;
                if (image.node.url.toLowerCase().includes(imageStringWithAttrAndSkinToneToFind.toLowerCase())) {
                    torsoBackImageSkintone = image.node.url;
                } else if (image.node.url.toLowerCase().includes(`/${attr}-back`)) {
                    torsoBackImage = image.node.url;
                }
            } else {
                const imageStringWithAttrAndSkinToneToFind = `Artwork-Back---${skintone}`;
                if (image.node.url.toLowerCase().includes(imageStringWithAttrAndSkinToneToFind.toLowerCase())) {
                    torsoBackImageSkintone = image.node.url;
                } else if (image.node.url.toLowerCase().includes('-back')) {
                    torsoBackImage = image.node.url;
                }
            }
        });
        this.setState({ torsoBackImage: torsoBackImageSkintone ? torsoBackImageSkintone : torsoBackImage });
    }

    render() {
        const {
                projectTitle,
                product,
                selected,
                onRemove,
                backButtonFunc,
                activeSection,
                selectedProducts,
                skintone,
                showDescription,
                setShowDescription,
            } = this.props,
            isSelected =
                selected !== null &&
                this.state.torsoText?.frontText === selected?.productFormJsonValues?.properties?.Text &&
                (this.state.torsoText?.backText ===
                    selected?.productFormJsonValues?.properties?.['Text for the back'] ||
                    !this.state.torsoText?.backText);

        const prodIdParsed = product && product.id?.split('/').pop();

        let isInStock = product.availableForSale;
        if (product.variants) {
            for (let i = product.variants.length, n = 0; i > n; n += 1) {
                if (!isInStock) isInStock = product.variants[n].available;
            }
        }

        let button = (
            <button
                type="button"
                className="btn button span product-buy"
                onClick={(e) => {
                    if (sectionHasProduct) {
                        this.setState({ showReplaceItemWarning: true });
                        this.setState({ formToSubmit: e.target.form });
                    } else {
                        this.submitProductForm(e.target.form);
                    }
                    // scroll to section.preview-section
                    const previewSection = document.querySelector('.preview-section');
                    previewSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }}
            >
                <span>Add to project</span>
            </button>
        );
        if (isSelected) {
            button = (
                <button
                    type="button"
                    className="btn button span inverse product-buy product-remove"
                    onClick={(e) => {
                        onRemove(product, e.target.form);
                    }}
                >
                    <span>Remove from project</span>
                </button>
            );
        }

        let productPrice = '';
        if (this.state.attributes?.priceV2) {
            productPrice = this.state.attributes.priceV2.amount;
        } else if (this.props?.product?.variants?.nodes) {
            productPrice = this.props?.product?.variants?.nodes[0].priceV2.amount;
        } else if (this.props?.product?.variants?.edges) {
            productPrice = this.props?.product?.variants?.edges[0].node.priceV2.amount;
        }
        let productStockDisplay = false;
        const sectionHasProduct = selectedProducts[activeSection] !== null;

        const productContainerClasses = classNames('product-main h-product', {
            'section-has-product': isSelected,
            'section-bodies': activeSection === 'bodies',
        });

        const attributesVars = product.variants.nodes ? product.variants.nodes : product.variants.edges;
        const reverseImage = this.state.attributes?.reverseImage;

        return (
            <div className={productContainerClasses}>
                <h2 className="product-main-title">{product?.title?.split('-')[0]}</h2>

                <ProductWarningText product={product} />

                <button type="button" className="pagetitle-back pagetitle-back-category" onClick={backButtonFunc}>
                    Back
                </button>

                <div className="product-details">
                    <div className="product-details-inner">
                        <div className="product-form">
                            <form
                                action="/cart/add"
                                method="post"
                                encType="multipart/form-data"
                                id={`AddToCartForm-${prodIdParsed}`}
                                className="product-form"
                            >
                                <div className="options-container">
                                    <Attributes
                                        attributes={product.attributes}
                                        activeSection={activeSection}
                                        skintone={skintone}
                                        optionLabel={product?.options && product?.options[0]?.name}
                                        variations={
                                            product.variants.nodes ? product.variants.nodes : product.variants.edges
                                        }
                                        selected={this.state.dropdownDefaultValue}
                                        onChange={(attribute, value) => this.changeAttribute(attribute, value)}
                                    />

                                    {(activeSection === 'bodies' || reverseImage) && (
                                        <div className="product-torso-switcher">
                                            <button
                                                className={`show-front ${!this.state.showBackImage ? 'active' : ''}`}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    this.setState({ showBackImage: false });
                                                }}
                                            >
                                                Front
                                            </button>
                                            <button
                                                className={`show-back ${this.state.showBackImage ? 'active' : ''}`}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    this.setState({ showBackImage: true });
                                                }}
                                            >
                                                Back
                                            </button>
                                        </div>
                                    )}
                                </div>

                                {activeSection === 'hatsAndHair' ||
                                (activeSection === 'display' && attributesVars.length <= 1) ? (
                                    <Slideshow images={product.images?.edges} attr={this.state.attributes} />
                                ) : (
                                    <ProductImageView
                                        defaultImage={product.featuredImage}
                                        attr={this.state.attributes}
                                        backImageSrc={this.state.torsoBackImage || reverseImage?.reference?.image?.url}
                                        showBackImage={this.state.showBackImage}
                                        torsoOverlayImages={this.state.torsoOverlayImages}
                                        activeSection={activeSection}
                                        currentProductId={product.id}
                                        selectedProducts={selectedProducts}
                                        torsoTextState={this.state.torsoText}
                                        productTags={product.tags}
                                        product={product}
                                        variations={
                                            product.variants.nodes ? product.variants.nodes : product.variants.edges
                                        }
                                    />
                                )}

                                <Addons
                                    addons={product.product_attribute}
                                    productId={prodIdParsed}
                                    frontTextEventListenerExists={this.state.frontTextEventListenerExists}
                                    backTextEventListenerExists={this.state.backTextEventListenerExists}
                                    setBackTextEventListenerExists={(bool) =>
                                        this.setState({
                                            backTextEventListenerExists: bool,
                                        })
                                    }
                                    setFrontTextEventListenerExists={(bool) =>
                                        this.setState({
                                            frontTextEventListenerExists: bool,
                                        })
                                    }
                                    torsoTextState={this.state.torsoText}
                                    setTorsoBackText={(backText) =>
                                        this.setState({
                                            torsoText: {
                                                ...this.state.torsoText,
                                                backText: backText,
                                            },
                                        })
                                    }
                                    setTorsoFrontText={(frontText) =>
                                        this.setState({
                                            torsoText: {
                                                ...this.state.torsoText,
                                                frontText: frontText,
                                            },
                                        })
                                    }
                                    sectionHasProduct={sectionHasProduct}
                                />

                                <input type="number" name="quantity" value="1" hidden readOnly />

                                <input
                                    type="text"
                                    id="projectTitle"
                                    name="properties[projectTitle]"
                                    value={projectTitle ? projectTitle : ''}
                                    hidden
                                    readOnly
                                />

                                {activeSection === 'bodies' && (
                                    <>
                                        <input
                                            type="hidden"
                                            name={`properties[_overlayImage]`}
                                            id="overlayImageValue"
                                            value={this.state.torsoOverlayImages.torsoOverlayImage}
                                            readOnly
                                        />

                                        <input
                                            type="hidden"
                                            name={`properties[_overlayHands]`}
                                            id="overlayHands"
                                            value={this.state.torsoOverlayImages.handImage}
                                            readOnly
                                        />
                                    </>
                                )}
                                <div
                                    className="product-description-container"
                                    onClick={() => setShowDescription(!showDescription)}
                                >
                                    <div
                                        className={`product-description ${showDescription ? 'expanded' : 'trimmed'}`}
                                        dangerouslySetInnerHTML={{
                                            __html: showDescription ? product.descriptionHtml : product.descriptionHtml,
                                        }}
                                    />
                                    {!showDescription && (
                                        <svg
                                            className="icon icon-info"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="800px"
                                            height="800px"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M16.5303 8.96967C16.8232 9.26256 16.8232 9.73744 16.5303 10.0303L12.5303 14.0303C12.2374 14.3232 11.7626 14.3232 11.4697 14.0303L7.46967 10.0303C7.17678 9.73744 7.17678 9.26256 7.46967 8.96967C7.76256 8.67678 8.23744 8.67678 8.53033 8.96967L12 12.4393L15.4697 8.96967C15.7626 8.67678 16.2374 8.67678 16.5303 8.96967Z"
                                                fill="#000000"
                                            />
                                        </svg>
                                    )}
                                </div>

                                <div className="product-price-container">
                                    <span className="product-price">
                                        <data className="p-price" value="">
                                            <span
                                                className="product-price"
                                                dangerouslySetInnerHTML={{ __html: `£${productPrice}` }}
                                            />
                                        </data>
                                        {productStockDisplay}
                                    </span>
                                </div>

                                {!isInStock ? (
                                    <p className="btn button span disabled">
                                        <span>Sold out</span>
                                    </p>
                                ) : (
                                    button
                                )}
                                <p
                                    className={classNames('product-copyright', {
                                        'product-copyright-expanded': this.state.showingCopyright,
                                    })}
                                    onClick={() =>
                                        this.setState({
                                            showingCopyright: !this.state.showingCopyright,
                                        })
                                    }
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                                        <path d="M8 0a8 8 0 1 0 8 8 8 8 0 0 0-8-8Zm-.16 2.96a1.333 1.333 0 0 1 1.325 1.331A1.317 1.317 0 0 1 7.84 5.6a1.3 1.3 0 0 1-1.306-1.314A1.315 1.315 0 0 1 7.848 2.96Zm2.507 9.965a.115.115 0 0 1-.115.115H5.883a.115.115 0 0 1-.115-.115v-.64a.117.117 0 0 1 .115-.117h.9a.4.4 0 0 0 .114-.232 1.947 1.947 0 0 0 .014-.274V8.347c0-.48-.16-.64-.64-.661h-.613v-.564l3.6-.128v4.774a.48.48 0 0 0 .112.392h.87a.117.117 0 0 1 .115.117Z"></path>
                                    </svg>
                                    LEGO® is a trademark of the LEGO Groups of companies. The LEGO Group does not
                                    sponsor, authorise or endorse this website nor any of the customised/modified
                                    products or sets shown on it nor does it accept responsibility in any way, shape or
                                    form for any unforeseen and/or adverse consequences following from such
                                    customisation/modification.
                                </p>
                            </form>
                        </div>
                    </div>
                </div>

                {this.state.showReplaceItemWarning && this.state.formToSubmit && (
                    <Warning
                        actionConfirm={() => {
                            this.setState({
                                showReplaceItemWarning: false,
                            });
                            this.submitProductForm(this.state.formToSubmit);
                        }}
                        warningText="Are you sure you want to make this change?"
                        actionDeny={() => {
                            this.setState({
                                showReplaceItemWarning: false,
                            });
                        }}
                    />
                )}
            </div>
        );
    }
}

Customise.propTypes = {
    currentBuildIndex: PropTypes.number,
    product: PropTypes.object.isRequired,
    skintone: PropTypes.string,
    selected: PropTypes.object,
    onSelect: PropTypes.func,
    onRemove: PropTypes.func,
    showDescription: PropTypes.bool,
    setShowDescription: PropTypes.func,
};

Customise.defaultProps = {
    selected: null,
    onSelect: () => {},
    onRemove: () => {},
};

const mapStateToProps = (state) => {
    return {
        currentBuildIndex: state.currentBuildIndex,
        activeSection: state.navigation.selected,
        skintone: state.builds[state.currentBuildIndex].skintone,
        selectedProducts: state.builds[state.currentBuildIndex].selected,
        torsoReduxText: state.builds[state.currentBuildIndex].torsoText,
    };
};

export default connect(mapStateToProps)(Customise);
